<div class="modal-top-bar">
    <div class="modal-top-left-action"></div>

    <!-- Title -->
    <div class="modal-top-title">
       <span class="modal-title-strong">{{ 'order_page_review_modal_title' | translate}} {{ "#" + (tempData$ | async)?.slug }}</span> 
    </div>

    <!-- Cancel button -->
    <div class="modal-top-right-action" >
        <div class="action-item" (click)="onCancel()">
            {{ 'dashboard_modal_filter_close' | translate }}
        </div>
    </div>
</div>

<div class="modal-content" #modalContent>
    <!-- Restaurant -->
    <div class="restaurant-name">
        {{ 'order_page_review_modal_restaurant' | translate}} {{ (tempData$ | async)?.restaurantName }}
    </div>

    <!-- Rating stars -->
    <div class="rating-container">
        <div class="rating-title">
            {{ 'order_page_review_modal_rating' | translate}}
        </div>
        <div class="rating-stars">
            <span class="rate" (mouseleave)="hoverRating = 0">
                <i *ngFor="let star of stars; let index = index"
                    (click)="setRating(index + 1)"
                    (mouseenter)="hoverRating = index + 1"
                    [ngClass]="{'active': (hoverRating ? index < hoverRating : index < ((reviewData$ | async)?.rating || 0))}">
                ★
                </i>
            </span>
        </div>
    </div>

    <!-- Comment -->
    <div class="rating-container">
        <div class="rating-title">
            {{ 'order_page_review_modal_comment' | translate}}
        </div>
        <div class="rating-stars pt-2">
            <fs-textarea [label]="''"
                        [inputValue]="''"
                        (valueUpdate)="onTextUpdate($event)"
            ></fs-textarea>
        </div>
    </div>

    <!-- Button to submit -->
    <div class="cta-container">
            <fs-button [text]="'order_page_review_modal_submit'| translate"
                     [type]="'raised-primary'" [leadingIcon]="'send'"
                     [style]="'full-width-large-height'"
                     (onPress)="onSubmitPress()"
                     [disabled]="!(reviewData$ | async)?.rating">                     
          </fs-button>
    </div>
</div>
